import { render, staticRenderFns } from "./mp3-upload.vue?vue&type=template&id=256fcb70&scoped=true"
import script from "./mp3-upload.vue?vue&type=script&lang=ts"
export * from "./mp3-upload.vue?vue&type=script&lang=ts"
import style0 from "./mp3-upload.vue?vue&type=style&index=0&id=256fcb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256fcb70",
  null
  
)

export default component.exports